module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/AQ-700d4125e40aca5eb9c7c09b8f91f2b4.png";